import React from 'react';
import QRCodeSVG from 'react-qr-code';

interface QRCodeProps {
  url: string;
  size?: number;
  className?: string;
  qrCodeUrl?: string; // Optional pre-generated QR code from API
}

const QRCode: React.FC<QRCodeProps> = ({ url, size = 200, className = '', qrCodeUrl }) => {
  return (
    <div className={`qr-code-container ${className}`}>
      <div className="qr-code-label">
        <p>Scan to view or add photos!</p>
      </div>
      <div className="qr-code-wrapper">
        {qrCodeUrl ? (
          <img
            src={qrCodeUrl}
            alt="QR Code"
            style={{ 
              width: size, 
              height: size,
              backgroundColor: 'white',
              padding: '8px',
              borderRadius: '4px',
              display: 'block'
            }}
          />
        ) : (
          <div style={{ 
            backgroundColor: 'white', 
            padding: '8px', 
            borderRadius: '4px',
            display: 'inline-block'
          }}>
            <QRCodeSVG
              value={url}
              size={size}
              bgColor="#FFFFFF"
              fgColor="#000000"
              level="M"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default QRCode;
